import { registerAction } from '../../Action'
import { deserializeJson } from '../../jsonApiDeserializer'

const LOAD_INTEGRATION_TASK = 'LOAD_INTEGRATION_TASK'

const reducer = (state = {}, action) => ({
  ...deserializeJson({ payload: action.payload, state }),
})

const loadIntegrationTask = registerAction(LOAD_INTEGRATION_TASK, { reducer })

export default loadIntegrationTask
